export default "__VITE_ASSET__BxotNHdC__"